import React, { useEffect } from 'react';
import unsplash from '../api/unsplash';

import {
    DataGridPro,
    itIT,
    GridToolbarContainer,
    GridToolbarQuickFilter,
} from '@mui/x-data-grid-pro';
import { CustomFooterPersonalized } from '../utils/CustomFooterPersonalized';

import moment from 'moment';
import 'moment/locale/it';

import { AirplanemodeInactive, Flight } from '@mui/icons-material';
import {
    LinearProgress,
    Grid,
    Box,
    Card,
    CardContent,
    CardHeader,
    Tabs,
    Tab,
} from '@mui/material';
import PropTypes from 'prop-types';

function CustomTabPanel(props) {
    const { children, value, index, ...other } = props;

    return (
        <div
            role="tabpanel"
            hidden={value !== index}
            id={`simple-tabpanel-${index}`}
            aria-labelledby={`simple-tab-${index}`}
            {...other}
        >
            {value === index && <Box sx={{ p: 3 }}>{children}</Box>}
        </div>
    );
}

CustomTabPanel.propTypes = {
    children: PropTypes.node,
    index: PropTypes.number.isRequired,
    value: PropTypes.number.isRequired,
};

const DistaccatiRaw = () => {
    const [value, setValue] = React.useState(0);
    const [distaccatiA, setDistaccatiA] = React.useState([]);
    const [distaccatiDa, setDistaccatiDa] = React.useState([]);
    const handleChange = (event, newValue) => {
        setValue(newValue);
    };

    useEffect(() => {
        // è un loop qui carico i dati
        const fetchData = async () => {
            try {
                const distaccati = await unsplash.get('distacco/all', {
                    headers: {
                        Authorization: `Bearer ${localStorage.getItem('jwt')}`,
                    },
                });
                setDistaccatiA(distaccati.data.data.dataA);
                setDistaccatiDa(distaccati.data.data.dataDa);
            } catch (error) {
                console.error(error.message);
            }
        };
        fetchData();
    }, []);

    function CustomToolbar() {
        return (
            <GridToolbarContainer>
                <Grid
                    container
                    direction="row"
                    justifyContent="flex-start"
                    alignItems="center"
                >
                    <GridToolbarQuickFilter placeholder="Cerca..." />
                </Grid>
            </GridToolbarContainer>
        );
    }

    const columnsDa = [
        {
            field: 'cf_azienda',
            headerName: 'Codice Fiscale Azienda',
            width: 200,
            //flex: 1,
            headerAlign: 'center',
            align: 'center',
            sort: 'asc',
        },
        {
            field: 'azienda',
            headerName: 'Azienda',
            width: 200,
            //flex: 1,
            headerAlign: 'center',
            align: 'center',
            sort: 'asc',
        },
        {
            headerName: 'Cognome',
            field: 'cognome',
            width: 200,
            //flex: 1,
            headerAlign: 'center',
            align: 'center',
            sort: 'asc',
        },
        {
            headerName: 'Nome',
            field: 'nome',
            width: 200,
            //flex: 1,
            headerAlign: 'center',
            align: 'center',
            sort: 'asc',
        },
        {
            field: 'qualifica',
            headerName: 'Qualifica',
            width: 200,
            //flex: 1,
            headerAlign: 'center',
            align: 'center',
            sort: 'asc',
        },
        {
            field: 'livello',
            headerName: 'Livello',
            width: 200,
            //flex: 1,
            headerAlign: 'center',
            align: 'center',
            sort: 'asc',
        },

        {
            field: 'tipo',
            headerName: 'Tipo',
            width: 200,
            //flex: 1,
            headerAlign: 'center',
            align: 'center',
            sort: 'asc',
        },
        {
            field: 'azienda_distaccante',
            headerName: 'Azienda distaccante',
            width: 200,
            //flex: 1,
            headerAlign: 'center',
            align: 'center',
            sort: 'asc',
        },
        {
            field: 'data_inizio',
            headerName: 'Data Inizio Distaccamento',
            width: 200,
            //flex: 1,
            headerAlign: 'center',
            align: 'center',
            sort: 'asc',
            renderCell: (params) => {
                return params.row.data_inizio
                    ? moment(params.row.data_inizio).format('DD/MM/YYYY')
                    : '';
            },
        },
        {
            field: 'data_fine',
            headerName: 'Data Fine Distaccamento',
            width: 200,
            //flex: 1,
            headerAlign: 'center',
            align: 'center',
            sort: 'asc',
            renderCell: (params) => {
                return params.row.data_fine
                    ? moment(params.row.data_fine).format('DD/MM/YYYY')
                    : '';
            },
        },
        {
            field: 'perc_distaccato',
            headerName: 'Percentuale',
            width: 200,
            //flex: 1,
            headerAlign: 'center',
            align: 'center',
            sort: 'asc',
            renderCell: (params) => {
                return params.row.perc_distaccato
                    ? params.row.perc_distaccato + ' %'
                    : '';
            },
        },
        {
            field: 'perc_part_time',
            headerName: 'Percentuale Part Time',
            width: 200,
            //flex: 1,
            headerAlign: 'center',
            align: 'center',
            sort: 'asc',
            renderCell: (params) => {
                return params.row.perc_part_time
                    ? params.row.perc_part_time + ' %'
                    : '';
            },
        },
        {
            field: 'updatedAt',
            headerName: 'Data Modifica',
            width: 200,
            //flex: 1,
            headerAlign: 'center',
            align: 'center',
            sort: 'asc',
            renderCell: (params) => {
                return params.row.updatedAt
                    ? moment(params.row.updatedAt).format('DD/MM/YYYY')
                    : '';
            },
        },
    ];

    const columnsA = [
        {
            field: 'cf_azienda',
            headerName: 'Codice Fiscale Azienda',
            width: 200,
            //flex: 1,
            headerAlign: 'center',
            align: 'center',
            sort: 'asc',
        },
        {
            field: 'cognome_e_nome',
            headerName: 'Cognome e Nome',
            width: 200,
            //flex: 1,
            headerAlign: 'center',
            align: 'center',
            sort: 'asc',
        },
        {
            field: 'rag_sociale_distaccato',
            headerName: 'Azienda attuale',
            width: 200,
            //flex: 1,
            headerAlign: 'center',
            align: 'center',
            sort: 'asc',
        },

        {
            field: 'data_inizio_dist',
            headerName: 'Data Inizio Distaccamento',
            width: 200,
            //flex: 1,
            headerAlign: 'center',
            align: 'center',
            sort: 'asc',
            renderCell: (params) => {
                return params.row.data_inizio_dist
                    ? moment(params.row.data_inizio_dist).format('DD/MM/YYYY')
                    : '';
            },
        },
        {
            field: 'data_fine_dist',
            headerName: 'Data Fine Distaccamento',
            width: 200,
            //flex: 1,
            headerAlign: 'center',
            align: 'center',
            sort: 'asc',
            renderCell: (params) => {
                return params.row.data_fine_dist
                    ? moment(params.row.data_fine_dist).format('DD/MM/YYYY')
                    : '';
            },
        },
        {
            field: 'perc_distacco',
            headerName: 'Percentuale',
            width: 200,
            //flex: 1,
            headerAlign: 'center',
            align: 'center',
            sort: 'asc',
            renderCell: (params) => {
                return params.row.perc_distacco
                    ? params.row.perc_distacco + ' %'
                    : '';
            },
        },
        {
            field: 'updatedAt',
            headerName: 'Data Modifica',
            width: 200,
            //flex: 1,
            headerAlign: 'center',
            align: 'center',
            sort: 'asc',
            renderCell: (params) => {
                return params.row.updatedAt
                    ? moment(params.row.updatedAt).format('DD/MM/YYYY')
                    : '';
            },
        },
    ];

    return (
        <>
            <Grid item xs={12}>
                <Card sx={{ position: 'relative', my: 'auto' }}>
                    <CardHeader
                        sx={{ textAlign: 'center' }}
                        title={'Distaccati'}
                        titleTypographyProps={{ variant: 'h4' }}
                    />
                </Card>

                <Card sx={{ marginTop: '10px' }}>
                    <CardContent sx={{ p: 0 }}>
                        <Box sx={{ width: '100%' }}>
                            <Box
                                sx={{ borderBottom: 1, borderColor: 'divider' }}
                            >
                                <Tabs
                                    value={value}
                                    onChange={handleChange}
                                    centered
                                    aria-label="basic tabs example"
                                    variant="scrollable"
                                >
                                    <Tab
                                        icon={<AirplanemodeInactive />}
                                        iconPosition="start"
                                        label="Da"
                                    />
                                    <Tab
                                        icon={<Flight />}
                                        iconPosition="start"
                                        label="A"
                                    />
                                </Tabs>
                            </Box>

                            <CustomTabPanel value={value} index={0}>
                                <Box sx={{ height: '60vh', width: '100%' }}>
                                    <DataGridPro
                                        components={{
                                            Toolbar: CustomToolbar,
                                            Footer: CustomFooterPersonalized,
                                        }}
                                        slots={{
                                            loadingOverlay: LinearProgress,
                                        }}
                                        disableSelection={true}
                                        localeText={
                                            itIT.components.MuiDataGrid
                                                .defaultProps.localeText
                                        }
                                        rows={distaccatiDa}
                                        getRowId={(row) =>
                                            `${row.cf_azienda}-${row.codice_fiscale}`
                                        }
                                        columns={columnsDa}
                                    />
                                </Box>
                            </CustomTabPanel>
                            {
                                //#endregion
                            }
                            <CustomTabPanel value={value} index={1}>
                                <Box sx={{ height: '60vh', width: '100%' }}>
                                    <DataGridPro
                                        components={{
                                            Toolbar: CustomToolbar,
                                            Footer: CustomFooterPersonalized,
                                        }}
                                        slots={{
                                            loadingOverlay: LinearProgress,
                                        }}
                                        disableSelection={true}
                                        localeText={
                                            itIT.components.MuiDataGrid
                                                .defaultProps.localeText
                                        }
                                        rows={distaccatiA}
                                        getRowId={(row) =>
                                            `${row.cf_azienda}-${row.codice_fiscale_dipendente}`
                                        }
                                        columns={columnsA}
                                    />
                                </Box>
                            </CustomTabPanel>
                            {
                                //#endregion
                            }
                        </Box>
                    </CardContent>
                </Card>
            </Grid>
        </>
    );
};

export default DistaccatiRaw;
